import { Link } from 'react-router-dom';
import { EmptyState } from '@/components/common/states';
import { Button } from '@/components/ui/button';
import { urls } from '@/lib/urls';

export function NotFoundPage() {
  return (
    <EmptyState
      title="No such page"
      action={
        <Button asChild variant="outline">
          <Link to={urls.home()}>Go home</Link>
        </Button>
      }
    />
  );
}
